import { Card, CardContent, CardHeader } from "@mui/material";

export function ChartContainer(props: { title: React.ReactNode, action?: React.ReactNode, content: JSX.Element }) {

  return (
    <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <CardHeader
        title={props.title}
        sx={{ textAlign: "center", p: 1 }}
        action={props.action}
      />
      <CardContent sx={{ flexGrow: 1, p: 1 }}>
        {props.content}
      </CardContent>
    </Card>
  );
}